import { render, staticRenderFns } from "./AcoesLeilao.vue?vue&type=template&id=08e93bcc"
import script from "./AcoesLeilao.vue?vue&type=script&lang=js"
export * from "./AcoesLeilao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports